import { ConcreteMeasure } from "./Measure";
import { MeasureType } from "./MeasureType";

export class LengthMeasure extends ConcreteMeasure {
    constructor() {
        super();
        this.type = MeasureType.LENGTH;
    }
}